import type { PrestadorServico } from '@/types/ordemServico';

/**
 * Prestadores que um admin/atendente pode ATRIBUIR a uma OS na criação/edição.
 *
 * Retorna apenas os prestadores cujo membro da organização está **ativo**
 * (`profileIdsAtivos` = profile ids dos membros prestadores com
 * `organization_members.ativo = true`). Membros desativados ficam de fora
 * (perderam acesso via RLS). O campo `disponivel` foi removido em 2026-05-24 —
 * `organization_members.ativo` é agora o único gate de acesso.
 */
export function filtrarPrestadoresAtribuiveis(
  prestadores: PrestadorServico[],
  profileIdsAtivos: Set<string>,
): PrestadorServico[] {
  return prestadores.filter((p) => profileIdsAtivos.has(p.profile_id));
}
